export default __webpack_public_path__ + "assets/images/7e46ec142085a2b060818912355434b1.png";